// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"879d4ecb","107":"dd51f8d1","195":"1791036d","277":"77a2614b","342":"f667a35b","385":"80d3f463","481":"226d5dfa","739":"4e8ea29c","789":"c156adb2","825":"b942c2fb","858":"a6dc9911","880":"5d2e3ae2","974":"e8c8403b"}[chunkId] + ".chunk.js";
};